import { HttpErrorResponse } from "@angular/common/http";
import { createReducer, on } from "@ngrx/store";

import { HttpActionState } from "../../../main/pages/users/userslisting/store/users-listing.reducers";
import * as ConfirmInvitationActions from './confirm-invitation.actions';
import { ResponseCodeEnum } from "./response-code.enum";

export interface IErrorResponse {
    status: HttpActionState | ResponseCodeEnum,
    message: string
}

export interface IConformInvitationState {
    checkConfirmUrl?: string;
    checkConfirmationLinkStatus: HttpActionState | IErrorResponse
    onboardingStatus: HttpActionState | IErrorResponse
}

const initialState: IConformInvitationState = {
    checkConfirmUrl: null,
    checkConfirmationLinkStatus: HttpActionState.Init,
    onboardingStatus: HttpActionState.Init
}


export const conformInvitationReducers = createReducer(initialState,
    on(ConfirmInvitationActions.resetState, (state) => ({
        ...state,
        initialState
    })),
    on(ConfirmInvitationActions.fetchConfirmationSettings, (state, { apiUrl }) => ({
        ...state,
        checkConfirmUrl: apiUrl,
        checkConfirmationLinkStatus: HttpActionState.Busy
    })),

    on(ConfirmInvitationActions.fetchConfirmationSettingsSucceeded, (state) => ({
        ...state,
        checkConfirmationLinkStatus: HttpActionState.Done
    })),
    on(ConfirmInvitationActions.fetchConfirmationSettingsFailed, (state, { error }) => ({
        ...state,
        checkConfirmationLinkStatus: obtainConfirmationSettingsFailedStatus(error)
    })),


);


function obtainConfirmationSettingsFailedStatus(error: HttpErrorResponse): IErrorResponse {

    return {
        message: error.error.message || 'Something went wrong',
        status: [ResponseCodeEnum.Invalid, ResponseCodeEnum.Expired].indexOf(error.status) > -1 ? error.status : HttpActionState.Failed
    }
}
